<template>
  <div class="cart_sidebar">
    <div class="cart-head">
      <span>TUS PEDIDOS ({{totalCarrito}})</span>
      <i class="close-cart icon-close" @click="clickEsconder()"><a></a></i>
    </div>
    <div class="cart-body">
      <template v-for="item in carrito">
        <div class="date"><span>{{item.fecha | fechaCarrito}}</span></div>
          <ul class="items" v-for="itemProveedor in item.proveedor">
            <li class="item" v-for="plato in itemProveedor.platos">
              <div class="cart-item-detail">
                <p class="cart-item-name">{{plato.plato.nombre}}</p>
                <div class="cart-item-foot">
                  <!-- <span class="cart-item-price">$35.99</span> -->
                  <div class="quantity">
                    <a class="decrease" href="#" @click.prevent="disminuir(item.fecha, plato.plato)">–</a>
                    <span class="qty-value">{{plato.cantidad}}</span>
                    <a class="increase" href="#" @click.prevent="aumentar(item.fecha, plato.plato)">+</a>
                  </div>
                </div>
              </div>
              <div class="cart-item-photo" :style="{backgroundImage: 'url(' + plato.plato.urlThumb + ')'}"></div>
            </li>
          </ul>
      </template>
    </div>
    <div class="cart-footer">
      <div class="cart-total-price">TOTAL: <span class="price-value">{{totalCarrito}}</span></div>
      <router-link class="btn btn-primary btn-fill" to="/checkout" v-if="user.roles[0] === 'user' && carrito.length > 0">IR AL CHECKOUT</router-link>
      <router-link class="btn btn-primary btn-fill" to="/checkoutadmin" v-if="user.roles[0] === 'admincliente' && carrito.length > 0">IR AL CHECKOUT</router-link>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import moment from 'moment'
  import MixinCarrito from '../../mixins/Carrito'
  moment.locale('es')
  export default {
    data () {
      return {}
    },
    mixins: [MixinCarrito],
    props: ['mostrar', 'carrito', 'user'],
    filters: {
      fechaCarrito (val) {
        return moment(new Date(val)).utc().format('dddd, DD [de] MMMM')
      }
    },
    computed: {
      totalCarrito () {
        let suma = 0
        this.carrito.forEach((itemCarrito) => {
          itemCarrito.proveedor.forEach((proveedor) => {
            return proveedor.platos.map((plato) => {
              suma += plato.cantidad
            })
          })
        })
        return suma
      }
    },
    methods: {
      clickEsconder () {
        this.$emit('toggle-carrito')
      },
      clickVaciar () {
        console.log('vaciar')
      },
      aumentar (dia, plato) {
        const me = this
        if (!me.puedePedirPlato(dia, plato)) {
          me.$emit('mostrar-notificacion', 'No se pueden agregar más items de esta categoría', 'error')
          return false
        }
        me.$emit('agregar-carrito', dia, plato)
      },
      disminuir (dia, plato) {
        const me = this
        me.$emit('disminuir-cantidad', dia, plato)
      },
      mostrarCarrito () {
        $('body').addClass('show_sidebar')
      },
      esconderCarrito () {
        $('body').removeClass('show_sidebar')
      }
    },
    watch: {
      mostrar (newVal, oldVal) {
        console.log('newVal', newVal)
        console.log('oldVar', oldVal)
        if (newVal) {
          this.mostrarCarrito()
        } else {
          this.esconderCarrito()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CarritoLateral.vue?b7c0f968